import { render, staticRenderFns } from "./weekly.vue?vue&type=template&id=7fb7c7dc&scoped=true"
import script from "./weekly.vue?vue&type=script&lang=js"
export * from "./weekly.vue?vue&type=script&lang=js"
import style0 from "./weekly.vue?vue&type=style&index=0&id=7fb7c7dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb7c7dc",
  null
  
)

export default component.exports